import { createFileRoute } from '@tanstack/react-router'
import { ShiftRequestsPage } from '@/features/scheduler/pages/shift-requests-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/shift-requests'
)({
  validateSearch: (search: Record<string, unknown>) => ({
    tab:
      search.tab === 'participant'
        ? ('participant' as const)
        : search.tab === 'routine'
          ? ('routine' as const)
          : ('worker' as const),
  }),
  component: ShiftRequestsPage,
})
